(function(angular){
	'use strict';
	
	angular
		.module('recurringInvestmentReviewModule')
		.controller('recurringInvestmentReviewController', [
			'globalConfig',
			'SettingsFactory',
			'urlFactory',
			RecurringInvestmentReviewFunction
		]);

	function RecurringInvestmentReviewFunction(
		globalConfig,
		SettingsFactory,
		urlFactory
	){
		var recurringInvestment = this;

		function buildPayload() {
			return{
				investmentEntityId: recurringInvestment.recurringInvestmentScheduleDetails.investmentEntityId,
				paymentMethodId: recurringInvestment.recurringInvestmentScheduleDetails.paymentMethodId,
				amount: recurringInvestment.recurringInvestmentScheduleDetails.amount,
				frequency: recurringInvestment.recurringInvestmentScheduleDetails.frequency,
				firstInvestmentDayOfMonth: recurringInvestment.recurringInvestmentScheduleDetails.firstInvestmentDayOfMonth
			};
		}

		recurringInvestment.handleFormSubmit = function(){
			SettingsFactory.recurringInvestment.set(buildPayload())
				.then(function(){
					urlFactory.submitFormById('recurringInvestmentReviewForm');
				})
				.catch(function() {
					recurringInvestment.formSubmitted = false;
				});
		};

		recurringInvestment.$onInit = function() {
			angular.extend(recurringInvestment, globalConfig);
		};
	}
})(window.angular);